<template>
    <div>
        <base-section>
            <b-row>
                <b-col>
                    <base-subheading>Verlauf</base-subheading>
                </b-col>
                <b-col class="text-right">
                    <div class="history-current-date-block">{{ currentDate }}</div>
                </b-col>
            </b-row>
        </base-section>
        <b-form-group v-if="options"
                      label-cols-lg="1" content-cols-lg="11"
                      label="Einrichtung:"
                      v-slot="{ ariaDescribedby }"
        >
            <b-form-checkbox-group
                v-model="selected"
                :options="options"
                :aria-describedby="ariaDescribedby"
                class="location-filter"
                name="buttons-1"
                @input="handleFilter"
                buttons
                button-variant="outline-success"
            >
            </b-form-checkbox-group>
        </b-form-group>

        <div v-if="loading" class="d-flex justify-content-center mb-3">
            <b-spinner
                variant="secondary"
                label="Loading..."
                style="width: 3rem; height: 3rem;"
            ></b-spinner>
        </div>

        <base-section v-else-if="orders.length">
            <div>
                <b-table
                    striped
                    hover
                    show-empty
                    small
                    stacked="md"
                    :items="orders"
                    :fields="fields"
                    class="order"
                >
                    <template v-slot:cell(menuitem)="row">
                        <div style="font-size: 18px;">
                            <span :class="{'font-weight-bold': true,  'is_maxi': row.item.is_maxi}">{{
                                    row.item.categoryName
                                }}:</span><br>
                            {{ row.value }}
                        </div>
                    </template>
                    <template v-slot:cell(total)="row">
                        {{ row.value.toFixed(2) }} €
                    </template>
                    <template v-slot:cell(delete)="row">
                        <div
                            v-if="(row.item.type_numeric === 2 || row.item.type_numeric === 3) && row.item.can_be_deleted">
                            <delete-button :item="row.item"
                                           @reloadOrders="getHistory"></delete-button>
                        </div>
                        <div
                            v-else-if="(row.item.type_numeric === 1) && row.item.can_be_deleted">
                            <delete-button :item="row.item"
                                           icon="minecart-loaded"
                                           hoverText="Abholung stornieren"
                                           deleteMessage="Möchten Sie die Abholung wirklich stornieren?"
                                           type="cancel"
                                           @reloadOrders="getHistory"></delete-button>
                        </div>
                    </template>
                </b-table>
            </div>
        </base-section>
        <base-section v-else>
            <h4>Keine Bestellungen für heute</h4>
        </base-section>
    </div>
</template>

<script>
import BaseSubheading       from "@/components/base/Subheading";
import BaseSection          from "@/components/base/Section";
import {getHistoryRequest}  from "@/api/history";
import RemoveOrderComponent from "../components/menu/RemoveOrderComponent";
import {mapGetters}         from "vuex";

export default {
    name:       'History',
    components: {BaseSection, BaseSubheading, 'delete-button': RemoveOrderComponent},
    data() {
        return {
            loading:  false,
            orders:   [],
            selected: [],
            filters:  [],
            fields:   [
                {key: 'consumer', label: 'Kunde'},
                {key: 'location', label: 'Einrichtung'},
                {key: 'menuitem', label: 'Menü'},
                {key: 'type', label: 'Art der Bestellung'},
                {key: 'quantity', label: ''},
                {key: 'total', label: 'Summe'},
                {key: 'pickedup_at', label: 'Abgeholt'},
                {key: 'delete', label: ''},
            ],
        };
    },
    computed: {
        ...mapGetters(['userLocations']),
        currentDate() {
            return this.formatDate(new Date());
        },
        options() {
            const self = this;

            for (let location of self.userLocations) {
                self.filters.push({
                    'text':  location.name,
                    'value': location.id,
                })
            }

            return self.filters;
        },
    },
    async created() {
        this.loading = true;
        await this.getHistory()
    },
    methods: {
        async handleFilter() {
            const self = this;

            self.loading = true;

            await getHistoryRequest(self.selected)
                .then(res => {
                    self.orders  = res.data;
                    self.loading = false;
                });
        },
        async getHistory() {
            await getHistoryRequest()
                .then(res => {
                    this.orders  = res.data;
                    this.loading = false;
                });
        },
        formatDate(day) {
            const dd   = String(day.getDate()).padStart(2, '0');
            const mm   = String(day.getMonth() + 1).padStart(2, '0');
            const yyyy = day.getFullYear();

            return dd + '.' + mm + '.' + yyyy;
        },
    },
}
</script>


<style lang="scss">
@import "../assets/styles/custom_theme";

> > > .round-btn {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 42px;
    height: 42px;
    border-radius: 50%;
    cursor: pointer;
    color: #ffffff;
}

> > > .btn-remove {
    background-color: $red;
}

> > > .location-filter .btn-outline-success {
    color: $accent-color;
    border-color: $accent-color;
    margin-right: 10px !important;
    border-radius: 20px !important;
    padding: 6px !important;
}

> > > .location-filter {
    display: block !important;
}

> > > .location-filter label {
    margin-bottom: 4px !important;
}

.is_maxi {
    background-color: $light-grey !important;
    padding: 4px;
    margin-left: -4px;
    background: border-box;
    border-radius: 5px;
}

.history-current-date-block {
    padding: 12px 10px 0 0;
}
</style>
